export type DST = {
  data: Array<{
    state: number;
    scholarshipCodeDetails?: {
      code: string;
      discountPercentage: number;
      validTill?: string;
    };
    timeRemaining?: number;
    attemptsLeft?: number;
    finishTime?: number;
    resultGenerationTimestamp?: string;
    quizUid?: string;
    sessionUid: string;
  }>;
  extraBlockInfo: {
    header: string;
    subHeader: string;
    ctaList: Array<{
      label: any;
      meta: {
        quizUid?: string;
        sessionUid?: string;
        label?: string;
      };
    }>;
  };
};

export const DST_STATES = {
  UNATTEMPTED: 0,
  RESUME: 1,
  ATTEMPTED: 2,
  REATTEMPT: 3,
  WON: 4
};

export const DST_POLLING_INTERVAL = 5000;
export const DST_MAX_POLLING_ATTEMPTS = 3;
export const GOLD_CARD_MAX = 100;
export const GOLD_CARD_MIN = 39;
export const PURPLE_CARD_LIMIT = 10;
